// extracted by mini-css-extract-plugin
export default {"coloredButton":"ColoredButton_coloredButton__ZNCbl"};